<template>
    <div class="select-wrap">
        <label>数据纬度</label>
        <div @click="toggleInput" class="input">{{ selected.join(';') }}</div>
        <div class="select-box" v-if="show_select">
            <div class="list">
                <div
                    v-for="type in types"
                    :key="type"
                    class="checkbox"
                    :class="{ disabled: disabled && !inner_selected.includes(type) }"
                    @click="selectItem(type)"
                >
                    <input type="checkbox" :disabled="disabled && !inner_selected.includes(type)" :checked="inner_selected.includes(type)"/>
                    <span>{{ type }}</span>
                </div>
            </div>
            <div class="btns">
                <button @click="confirm" class="primary">确认</button>
                <button @click="toggleInput" class="normal">取消</button>
            </div>
        </div>
    </div>
</template>
<script>
export const DATA_TYPES = [
    `楼盘曝光次数`,
    `楼盘关注次数`,
    `楼盘评论数量`,
    `拨打置业顾问电话次数`,
    `拨打售楼部电话次数`,
    `微聊-用户微聊置业顾问的会话数量(人天)`,
    `VR看房点击次数`,
    `VR看房点击人数`,
    `航拍点击次数`,
    `航拍点击人数`,
]
export const DATA_KEYS = {
    '楼盘曝光次数': 'view_count',
    '楼盘关注次数': 'follow_times',
    '楼盘评论数量': 'comment_count',
    '拨打置业顾问电话次数': 'call_consultant_times',
    '拨打售楼部电话次数': 'call_building_times',
    '微聊-用户微聊置业顾问的会话数量(人天)': 'tim_session_count',
    'VR看房点击次数': 'vr_view_times',
    'VR看房点击人数': 'vr_view_users',
    '航拍点击次数': 'panorama_view_times',
    '航拍点击人数': 'panorama_view_users',
}
export default {
    props: {
        selected: Array
    },
    data () {
        return {
            types: DATA_TYPES,
            inner_selected: this.selected.slice(0) || [],
            show_select: false
        }
    },
    computed: {
        disabled () {
            return this.inner_selected.length >= 5
        }
    },
    methods: {
        toggleInput () {
            this.show_select = !this.show_select
        },
        selectItem (type) {
            const index = this.inner_selected.indexOf(type)
            if (index > -1) {
                this.inner_selected.splice(index, 1)
            } else if (!this.disabled) {
                this.inner_selected.push(type)
            }
        },
        confirm () {
            this.$emit('change', this.inner_selected)
            this.toggleInput()
        }
    }
}
</script>
<style lang="scss" scoped>
.select-wrap {
    display: inline-flex;
    align-items: center;
    position: relative;
    height: 40px;
    margin-left: 20px;
    > label {
        font-size: 14px;
        color: #666666;
    }
    .input {
        width: 400px;
        height: 40px;
        line-height: 40px;
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 0;
        background-color: rgba(0, 0, 0, 0.02);
        border: 1px solid rgba(0, 0, 0, 0.15);
    }
}
.select-box {
    position: absolute;
    top: 100%;
    width: 700px;
    padding: 24px;
    background-color: #fff;
    border: 1px solid #00B399;
    .list {
        display: flex;
        flex-wrap: wrap;
    }
    .checkbox {
        display: inline-flex;
        align-items: center;
        height: 30px;
        margin-right: 24px;
        &.disabled {
            color: #999;
        }
    }
    .btns {
        display: flex;
        justify-content: center;
        button {
            width: 56px;
            height: 30px;
            border-radius: 4px;
        }
        .primary {
            background-color: #00B59D;
            color: #fff;
            border: 1px solid transparent;
        }
        .normal {
            background:#fff;
            border: 1px solid #CCCCCC;
            margin-left: 1em;
            color: #444444;
        }
    }
}
</style>